import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { LogIn, ArrowLeft, Mail, Lock } from "lucide-react";

import { loginUser } from "../../actions/authActions";

import {
  Card,
  Input,
  FormField,
  Button,
} from "../../design-system";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      errors: {},
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.history.push("/dashboard");
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.auth.isAuthenticated && !prevProps.auth.isAuthenticated) {
      this.props.history.push("/dashboard");
    }
    if (this.props.errors !== prevProps.errors) {
      this.setState({
        errors: this.props.errors || {},
        loading: false,
      });
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      errors: { ...this.state.errors, [e.target.id]: "" },
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true, errors: {} });
    const userData = {
      email: this.state.email,
      password: this.state.password,
    };
    this.props.loginUser(userData, this.props.history);
  };

  render() {
    const { errors, loading } = this.state;

    return (
      <div
        data-ds-theme="default"
        className="fixed inset-0 overflow-y-auto bg-bg text-text flex flex-col"
      >
        <main className="flex-1 flex items-center justify-center px-4 py-12">
          <div className="w-full max-w-md">
            <div className="text-center mb-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 mb-6 text-mute hover:text-text transition-colors"
              >
                <img src="/img/logo.png" alt="Portfolio" className="w-10 h-10 object-contain" />
                <span className="text-lg font-bold tracking-tight">
                  Portfolio<span className="font-serif italic font-normal align-baseline">.</span>
                </span>
              </Link>
              <p className="ds-eyebrow mb-2">— Admin</p>
              <h1 className="text-[44px] leading-[0.95] tracking-tight font-bold">
                Bon retour,<br />
                <span className="font-serif italic font-normal">on continue ?</span>
              </h1>
              <p className="text-sm text-mute mt-3">
                Connecte-toi pour accéder à l'administration.
              </p>
            </div>

            <Card className="p-6">
              <form noValidate onSubmit={this.onSubmit} className="space-y-4">
                <FormField label="Email" error={errors.email}>
                  <Input
                    id="email"
                    type="email"
                    autoComplete="email"
                    placeholder="admin@example.com"
                    value={this.state.email}
                    onChange={this.onChange}
                    isDisabled={loading}
                    isInvalid={Boolean(errors.email)}
                    leftIcon={<Mail className="w-4 h-4" strokeWidth={1.8} />}
                  />
                </FormField>

                <FormField label="Mot de passe" error={errors.password}>
                  <Input
                    id="password"
                    type="password"
                    autoComplete="current-password"
                    placeholder="••••••••"
                    value={this.state.password}
                    onChange={this.onChange}
                    isDisabled={loading}
                    isInvalid={Boolean(errors.password)}
                    leftIcon={<Lock className="w-4 h-4" strokeWidth={1.8} />}
                  />
                </FormField>

                <Button
                  type="submit"
                  fullWidth
                  size="lg"
                  isLoading={loading}
                  leftIcon={<LogIn className="w-4 h-4" strokeWidth={1.8} />}
                >
                  {loading ? "Connexion…" : "Se connecter"}
                </Button>
              </form>
            </Card>

            <div className="text-center mt-6">
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 text-[12.5px] text-mute hover:text-text transition-colors"
              >
                <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.8} />
                Retour à l'accueil
              </Link>
            </div>
          </div>
        </main>

        <footer className="px-4 py-4 text-center text-[11px] font-mono uppercase tracking-wider text-mute-2">
          Portfolio Admin · Ascencia
        </footer>
      </div>
    );
  }
}

Login.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { loginUser })(withRouter(Login));
